// src/services/deviceService.js

const DEVICE_API_URL =
  "https://devicefunctionskm.azurewebsites.net/api/TextWorker";
const DEVICE_API_KEY = import.meta?.env?.VITE_DEVICE_API_KEY;

const defaultHeaders = {
  "Content-Type": "application/json",
};

const postDeviceCommand = async (command, params) => {
  const url = DEVICE_API_KEY
    ? `${DEVICE_API_URL}?code=${encodeURIComponent(DEVICE_API_KEY)}`
    : DEVICE_API_URL;

  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    // credentials removed to simplify CORS
    headers: defaultHeaders,
    body: JSON.stringify({ c: command, p: params }),
  });
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(text || `Device API request failed: ${response.status}`);
  }
  // Try JSON, fallback to text
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};

export const getValveStatus = async (guid) => {
  if (!guid) throw new Error("Missing guid");
  const result = await postDeviceCommand("getstatus", [guid, "Valve"]);
  // Normalize response to one of: "Open" | "Closed" | "Unknown"
  const normalize = (val) => {
    if (!val) return "Unknown";

    // API shape example: { p: ["Opened"], m: 13 }
    if (typeof val === "object") {
      if (Array.isArray(val.p) && val.p.length > 0) {
        return normalize(val.p[0]);
      }
      if (val.t) return normalize(val.t);
      if (val.Status) return normalize(val.Status);
    }

    if (typeof val === "string") {
      const lower = val.toLowerCase();
      if (lower.includes("open")) return "Open"; // handles "open", "opened"
      if (lower.includes("close")) return "Closed"; // handles "close", "closed"
      return "Unknown";
    }

    return "Unknown";
  };

  return normalize(result);
};

export const setValveStatus = async (guid, status) => {
  if (!guid) throw new Error("Missing guid");
  const desired = status === "Open" ? "Open" : "Close";
  await postDeviceCommand("setstatus", [guid, "Valve", desired]);
};

export const openValve = async (guid) => setValveStatus(guid, "Open");
export const closeValve = async (guid) => setValveStatus(guid, "Close");
